import { render, staticRenderFns } from "./CreateDiscount.vue?vue&type=template&id=249671fa&scoped=true&"
import script from "./CreateDiscount.vue?vue&type=script&lang=js&"
export * from "./CreateDiscount.vue?vue&type=script&lang=js&"
import style0 from "./CreateDiscount.vue?vue&type=style&index=0&id=249671fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249671fa",
  null
  
)

export default component.exports